/** Placeholder routes pro fáze 2. V0.2 fáze 4-7 nahradí konkrétními
 *  obrazovkami z prototypu (DashboardMain, ThisWeek, DetailMain, Saldo, ...). */

import type { ReactNode } from "react";
import { Empty } from "@/components/ui/empty";
import { t } from "@/i18n/de";

function Page({ title, children }: { title: string; children?: ReactNode }) {
  return (
    <div style={{ padding: "32px 36px", maxWidth: 1280, margin: "0 auto" }}>
      <h1 className="display" style={{ margin: 0, fontSize: 28 }}>
        {title}
      </h1>
      <div style={{ marginTop: 28 }}>
        {children ?? <Empty title="Bald verfügbar.">In der nächsten Iteration.</Empty>}
      </div>
    </div>
  );
}

export function InvoiceDetailRoute() {
  return <Page title="Rechnung" />;
}

export function NotFoundRoute() {
  return (
    <div
      style={{
        padding: 60,
        textAlign: "center",
        color: "var(--text-3)",
      }}
    >
      {t.notFound}
    </div>
  );
}
